import { Alert, Spinner, Button as ReactButton } from '@a-ui/react';
import React from 'react';
import Ticket from '../../components/Ticket';
import Typography from '../../components/Typography';
import { api } from '../../hooks/api.hooks';
import { translate } from '../../i18n';
import { ITranslations } from '../../i18n/config';
import { usePagination } from './hooks';

interface ECounterTicketsProps {
  endpoint: string;
  loadMoreLabel: ITranslations;
  emptyMessage: ITranslations;
}

const ECounterTickets: React.FC<ECounterTicketsProps> = ({
  endpoint,
  loadMoreLabel,
  emptyMessage,
}) => {
  const [isLoading, setLoading] = React.useState(true);
  const { items, hasMore, loadMore } = usePagination<Api.Ticket>(
    async (offset: number, limit: number) => {
      setLoading(true);
      const { data } = await api.get<Api.Ticket[]>(endpoint, {
        params: {
          offset,
          limit,
        },
      });

      setLoading(false);
      return data;
    },
  );

  const hasOpenRequests = React.useMemo(() => {
    return items.some((item: Api.Ticket) =>
      ['draft', 'pendingpayment', 'actionrequired', 'todo', 'doing'].includes(item.status),
    );
  }, [items]);

  return (
    <div className="u-margin-top">
      {!hasOpenRequests && !isLoading && (
        <Alert inline className="u-margin-bottom">
          <Typography>{translate(emptyMessage)}</Typography>
        </Alert>
      )}
      {items.map((ticket) => (
        <Ticket key={ticket.id} data={ticket} />
      ))}
      {!items.length && isLoading && <Spinner />}
      {items.length > 0 && hasMore && (
        <div className="u-margin-top">
          <ReactButton
            theme="neutral"
            onClick={loadMore}
            {...(isLoading ? { addOn: { type: 'spinner', align: 'left' } } : {})}
          >
            {translate(loadMoreLabel as ITranslations)}
          </ReactButton>
        </div>
      )}
    </div>
  );
};

export default ECounterTickets;
